import { rateDiscriminatorLabel } from "../../rate/rate-discriminator-label.const";
import {
  SurchargeTypeRate,
  SurchargeTypeRateDto,
} from "./surcharge-type-rate.model";

export class SurchargeTypeRateMapper {
  public static map(data: SurchargeTypeRateDto): SurchargeTypeRate {
    return {
      id: data.id,
      name: data.name,
      type: data.type,
      discriminator: data.discriminator,
      discriminatorLabel:
        rateDiscriminatorLabel[data.discriminator] ?? data.discriminator,
      validFrom: data.validFrom ? new Date(data.validFrom) : null,
      validTill: data.validTill ? new Date(data.validTill) : null,
    };
  }
}
